import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01c1eaca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-left" }
const _hoisted_2 = { class: "header-icons" }
const _hoisted_3 = {
  key: 0,
  src: "/images/alert-icon.png",
  class: "icon-badge alert-badge",
  alt: "アラート"
}
const _hoisted_4 = {
  key: 1,
  src: "/images/icon_line.png",
  class: "icon-badge line-badge",
  alt: "LINE"
}
const _hoisted_5 = {
  key: 2,
  src: "/images/hotpepper-icon.ico",
  class: "icon-badge hotpepper-badge",
  alt: "HotPepper"
}
const _hoisted_6 = { class: "header-labels-left" }
const _hoisted_7 = {
  key: 0,
  class: "header-label-right"
}
const _hoisted_8 = { class: "event-content" }
const _hoisted_9 = { class: "booking-info" }
const _hoisted_10 = { class: "booking-id" }
const _hoisted_11 = { class: "customer-name" }
const _hoisted_12 = {
  key: 0,
  class: "customer-name-kana"
}
const _hoisted_13 = {
  key: 1,
  class: "customer-category"
}
const _hoisted_14 = { class: "event-time" }
const _hoisted_15 = {
  key: 0,
  class: "menu-section"
}
const _hoisted_16 = { class: "menu-text" }

import { withDefaults, computed, onBeforeMount, ref, inject } from "vue";
import { AnyFn, Fn, get, set } from "@vueuse/core";
import { IBooking } from "@/clinic/typings";
import { EventClickArg, EventInput } from "@fullcalendar/core";
import { BookingActionEnum, BookingStatusColorClass } from "@/clinic/typings/enums/booking";
import { EventImpl } from "@fullcalendar/core/internal";
import { Dictionary } from "@fullcalendar/core/internal";
import moment from "moment";

type IEventType = {
  event: EventImpl;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'day',
  props: {
    event: null
  },
  setup(__props: any) {

const props = __props as { event: EventImpl };



const extendedProps = computed((): Dictionary => props.event.extendedProps);

const {
  staff,
  customerName,
  customerNameKana,
  customerStatus,
  customerStatusDisplayName,
  medicalMenuName,
  bookingSource,
  bookingType,
  hotpepperConfirmed,
  specialNotes,
  reservationId,
  customerCategoryName,
  medicalMenu,
  additionalMenus,
  medicalOptionNames,
  status,
} = get(extendedProps);

/**
 * 予約IDを6桁のゼロパディング形式でフォーマット
 * @returns {string} ゼロパディングされた予約ID（例: "000123"）
 */
const formattedBookingId = computed((): string => {
  const id = reservationId || props.event.id;
  return String(id).padStart(6, "0");
});

/**
 * 予約の開始時間をフォーマット
 * @returns {string} HH:mm形式の開始時間（例: "10:30"）
 */
const formattedStartTime = computed((): string => {
  return moment(props.event.start).format("HH:mm");
});

/**
 * 予約の終了時間をフォーマット
 * @returns {string} HH:mm形式の終了時間（例: "12:00"）
 */
const formattedEndTime = computed((): string => {
  return moment(props.event.end).format("HH:mm");
});

/**
 * メニュー全体の文字列を40文字で省略表示
 * メインメニューとオプションメニューを結合し、40文字を超える場合は省略記号を付与
 * @returns {string} メニューテキスト（例: "カット(30分) + カラー(60分) + ..."）
 */
const truncatedMenuText = computed((): string => {
  let menuText = "";

  // メインメニュー
  if (medicalMenuName) {
    menuText += medicalMenuName;
    if (medicalMenu && medicalMenu.time_unit) {
      menuText += `(${medicalMenu.time_unit}分)`;
    }
  }

  // オプションメニュー（新しい方式）
  if (additionalMenus && additionalMenus.length > 0) {
    if (menuText) menuText += " + ";
    const optionTexts = additionalMenus.map(menu => `${menu.name}(${menu.duration}分)`);
    menuText += optionTexts.join(" + ");
  }
  // オプションメニュー（古い方式）
  else if (medicalOptionNames && medicalOptionNames.length > 0) {
    if (menuText) menuText += " + ";
    menuText += medicalOptionNames.join(" + ");
  }

  // 40文字で省略
  const maxLength = 40;
  if (menuText.length <= maxLength) {
    return menuText;
  }
  return menuText.substring(0, maxLength) + "...";
});

/**
 * 指名ラベルの表示判定
 * スタッフが存在し、かつdefault_staffがfalseの場合のみ表示
 * @returns {boolean} 指名ラベルを表示する場合はtrue
 */
const showNominationLabel = computed((): boolean => {
  return staff && !staff.default_staff;
});

/**
 * 顧客ステータスラベルの取得
 * customer_status_display_nameが存在する場合はそれを使用、
 * なければcustomer_statusから固定マッピングで取得
 * @returns {string} 顧客ステータスの表示名（例: "新規", "既存", "再来"）
 */
const customerStatusLabel = computed((): string => {
  // customer_status_display_nameが存在する場合はそれを使用
  if (customerStatusDisplayName) {
    return customerStatusDisplayName;
  }

  // フォールバック: customer_statusから判定
  if (customerStatus === "new") return "新規";
  if (customerStatus === "existed") return "既存";
  if (customerStatus === "revisited") return "再来";

  return ""; // 該当なしの場合は空文字
});

/**
 * 予約ソースラベルの取得
 * リクエスト予約またはHotpepper予約の場合にラベルを返す
 * @returns {string} ラベルテキスト（該当なしの場合は空文字）
 */
const sourceLabel = computed((): string => {
  // リクエスト予約の場合
  if (bookingType === "request") {
    return "リクエスト予約";
  }

  // Hotpepper予約の場合
  if (bookingSource === "hotpepper") {
    return "HotpepperBeauty予約";
  }

  return ""; // 該当なしの場合は空文字
});

/**
 * ソースラベルのCSSクラス名を取得
 * リクエスト予約とHotpepperで異なるスタイルを適用
 * @returns {string} CSSクラス名
 */
const sourceLabelClass = computed((): string => {
  if (bookingType === "request") {
    return "header-label-request";
  }
  if (bookingSource === "hotpepper") {
    return "header-label-hotpepper";
  }
  return "";
});

/**
 * イベントカードのCSSクラス名を取得
 * 予約ステータスと顧客ステータスの組み合わせから適切なクラスを返す
 * @returns {string} CSSクラス名（例: "bg-booking-new"）
 */
const eventColorClass = computed((): string => {
  // 予約（will_come）の場合、顧客ステータスと組み合わせる
  if (status === "will_come" && customerStatus) {
    const key = `will_come_${customerStatus}` as keyof typeof BookingStatusColorClass;
    const colorClass = BookingStatusColorClass[key];
    if (colorClass) {
      return colorClass;
    }
    // フォールバック: 既存顧客色
    return "bg-booking-existed";
  }

  // その他のステータス（キャンセル、来店済等）
  if (status) {
    const colorClass = BookingStatusColorClass[status as keyof typeof BookingStatusColorClass];
    if (colorClass) {
      return colorClass;
    }
  }

  // デフォルト: 既存顧客色
  return "bg-booking-existed";
});

const onShowBookingSidebar = ref<AnyFn>();

/**
 * イベントカードクリック時の処理
 * 予約詳細サイドバーを表示する
 * @returns {void}
 */
const onEventClick = () => {
  const { reservationId: id } = get(extendedProps);
  const showBookingSidebarFn =
    get(onShowBookingSidebar) ||
    ((_booking: IBooking, _action: string, _eventArg: EventClickArg | EventInput) => ({
      _booking,
      _action,
      _eventArg,
    }));
  showBookingSidebarFn({ id } as IBooking, BookingActionEnum.show, {
    event: props.event,
  } as EventClickArg);
};
onBeforeMount(() => set(onShowBookingSidebar, inject<Fn>("onShowBookingSidebar")));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["booking-event-card", `border-${_unref(eventColorClass)}`]),
    onClick: onEventClick
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["event-header", _unref(eventColorClass)])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_unref(specialNotes) && _unref(specialNotes).length != 0)
            ? (_openBlock(), _createElementBlock("img", _hoisted_3))
            : _createCommentVNode("", true),
          (_unref(bookingSource) == 'line')
            ? (_openBlock(), _createElementBlock("img", _hoisted_4))
            : _createCommentVNode("", true),
          (_unref(bookingSource) == 'hotpepper')
            ? (_openBlock(), _createElementBlock("img", _hoisted_5))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_unref(showNominationLabel))
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["header-label", `text-${_unref(eventColorClass)}`])
              }, "指名", 2))
            : _createCommentVNode("", true),
          (_unref(customerStatusLabel))
            ? (_openBlock(), _createElementBlock("span", {
                key: 1,
                class: _normalizeClass(["header-label", `text-${_unref(eventColorClass)}`])
              }, _toDisplayString(_unref(customerStatusLabel)), 3))
            : _createCommentVNode("", true)
        ])
      ]),
      (_unref(sourceLabel))
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("span", {
              class: _normalizeClass(_unref(sourceLabelClass))
            }, _toDisplayString(_unref(sourceLabel)), 3)
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(formattedBookingId)), 1),
        _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(customerName) || "顧客なし"), 1),
        (_unref(customerNameKana))
          ? (_openBlock(), _createElementBlock("span", _hoisted_12, "( " + _toDisplayString(_unref(customerNameKana)) + " )", 1))
          : _createCommentVNode("", true),
        (_unref(customerCategoryName))
          ? (_openBlock(), _createElementBlock("span", _hoisted_13, "(" + _toDisplayString(_unref(customerCategoryName)) + ")", 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(formattedStartTime)) + " 〜 " + _toDisplayString(_unref(formattedEndTime)), 1),
      (_unref(truncatedMenuText))
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(truncatedMenuText)), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})